import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { AxiosError } from 'axios';
import { customerUserKeys } from './customerUsers.key';

export function useDeleteCustomerUser() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({ customerUserId }: { customerUserId: string }) => {
    const api = await getApi();
    const res = await api.customerUserDeleteById(customerUserId);
    await queryClient.invalidateQueries({ queryKey: customerUserKeys.all });
    return res.data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => toast.success('Kund-användare borttagen'),
    onError: (e) => toast.error(extractError(e)),
  });
}

function extractError(e: unknown) {
  if (e instanceof AxiosError) {
    return e.response?.data?.message ?? 'Okänt fel';
  }
  return 'Okänt fel';
}
